"use client";

import React, { useState, useEffect } from "react";
import Image from "next/image";

import { Button } from "@components/ui";

import { Banner, BannerBottomShape, BannerBottomShapeLarge } from "@assets/icons";

const content = [
    {
        title: "WELCOME HOME",
        description: "You have financial dreams. ClearPath Lending can help make them a reality.",
    },
    {
        title: "BUYING A HOME?",
        description: "How exciting! ClearPath Lending will be with you every step of the way.",
    },
    {
        title: "REFINANCING?",
        description: "Find out how refinancing can help you reach your financial goals.",
    },
];

function BannerSlider() {
    const [isPaused, setIsPaused] = useState(false);
    const [activeSlide, setCurrentIndex] = useState(0);

    // Rotate content every 5 seconds
    useEffect(() => {
        const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (prefersReducedMotion || isPaused) return;

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % content.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [isPaused]);

    // Mobile-first layout
    return (
        <section
            className=" relative w-full bg-lightgray  h-auto xl-1920:pt-[30px]"
            aria-label="Promotional banner"
            aria-live="off"
        >
            <button
                type="button"
                onClick={() => setIsPaused((p) => !p)}
                aria-pressed={isPaused}
                className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-white focus:px-3 focus:py-2 focus:text-[#1275ba]"
            >
                {isPaused ? "Play banner" : "Pause banner"}
            </button>
            {/* Mobile View */}
            <div className="block md:hidden relative w-full h-[600px] md:h-auto 2xl:h-[600px]">
                <div className="absolute left-[58px] top-[280px] z-10">
                    <div className="relative">
                        <div className="overflow-visible">
                            <Image
                                src={Banner}
                                alt=""
                                aria-hidden="true"
                                role="presentation"
                                width={1000}
                                height={667}
                                className="w-[310px] h-[207px]"
                                priority
                            />
                        </div>
                    </div>
                </div>

                <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pb-[30rem] z-20">
                    <div className="transition-all duration-500 ease-in-out space-y-4 text-left pt-6">
                        <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-4xl font-bold text-darkBlue uppercase tracking-wide  ">
                            {content[activeSlide].title}
                        </h2>
                        <p
                            className="
                min-w-[287px] max-w-[287px]
                text-xl md:text-xl text-black
                font-normal leading-[22px]
                whitespace-normal
                font-lato
                transition-all duration-500
                opacity-100 translate-x-0 ease-in-out
            "
                            style={{
                                letterSpacing: "0px",
                            }}
                        >
                            {content[activeSlide].description}
                        </p>
                    </div>
                </div>

                <div className="absolute bottom-[335px] left-0 right-0 text-center z-30">
                    <Button
                        href="/loan-types"

                        className="mt-6 px-8 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
                    >
                        <span aria-hidden="true">Learn More</span>
                        <span className="sr-only">Learn more about Loan Types</span>
                    </Button>

                    <div className="mt-6 text-xl text-lightGrey">
                        OR CALL{" "}
                        <a
                            href="tel:8558665363"
                            aria-label="Call (855) 866-5363"
                            className="text-blue text-2xl font-bold pl-1"
                        >
                            (855) 866-5363
                        </a>
                    </div>
                </div>

                <div className="absolute bottom-0 left-0 w-full h-[120px] z-40 md:h-auto 2xl:h-[120px]">
                    <Image
                        src={BannerBottomShape}
                        alt=""
                        aria-hidden="true"
                        className="w-full h-[101%] object-fill"
                        priority
                    />
                </div>
            </div>

            {/* Medium & Large Screens */}
            <div className="hidden md:block">
                <div className="container mx-auto px-6 md:pr-0">
                    <div className="flex flex-col md:flex-row items-center justify-between h-[600px] lg:pl-0 xl:pl-[110px] xl:h-auto md:h-auto 2xl:h-[530px]">
                        {/* Text Content */}
                        <div className="flex flex-col justify-center items-start text-left md:w-1/2 space-y-4 z-20 lg:pb-48 2xl:pl-[120px] xl:pb-[270px]">
                            {/* Title & Description */}
                            <div className="flex flex-col items-start space-y-4 lg:space-y-2 lg:my-12">
                                <div className=" " style={{ inlineSize: "100%", overflowWrap: "break-word" }}>
                                    <h2 className="text-2xl md:text-3xl lg:text-2xl xl:text-4xl font-bold text-darkBlue uppercase tracking-wide  ">
                                        {content[activeSlide].title}
                                    </h2>
                                </div>
                                <div className=" " style={{ inlineSize: "100%", overflowWrap: "break-word" }}>
                                    <p
                                        className="text-xl md:text-xl lg:text-[14px] xl:text-2.9xl text-black font-normal 2xl:w-[513px] leading-7 xl:w-[513px]"
                                        style={{ letterSpacing: "0px" }}
                                    >
                                        {content[activeSlide].description}
                                    </p>
                                </div>
                            </div>

                            <div className="mt-6 flex flex-col lg:flex-row lg:items-center lg:space-x-4">
                                <Button
                                    href="/loan-types"
            
                                    className=" px-8 py-3 bg-blue-600 text-white rounded-full hover:bg-blue-700 transition"
                                >
                                    <span aria-hidden="true">Learn More</span>
                                    <span className="sr-only">Learn more about Loan Types</span>
                                </Button>
                                <div className="mt-6 lg:mt-0 text-lg text-lightGrey md:text-xl xl:text-[20px] font-bold">
                                    OR CALL{" "}
                                    <a
                                        href="tel:8558665363"
                                        aria-label="Call (855) 866-5363"
                                        className="text-blue text-xl md:text-2xl xl:pl-6 xl:text-[24px] font-bold"
                                    >
                                        (855) 866-5363
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Image */}
                        <div className="relative md:w-1/2 flex justify-center z-10 lg:pb-28 xl:pb-0">
                            <Image
                                src={Banner}
                                alt=""
                                aria-hidden="true"
                                width={570}
                                height={380}
                                className="w-auto h-auto md:h-auto lg:w-[551px] lg:h-[368px] xl:mb-[162px]  xl:ml-[115px] 2xl:mr-2 2xl:ml-0"
                                priority
                            />
                        </div>
                    </div>
                </div>

                {/* Bottom Shape */}
                <div className="absolute bottom-0 left-0 w-full h-[120px] z-0 2xl:h-[151px] md:h-auto">
                    <Image
                        src={BannerBottomShapeLarge}
                        alt=""
                        aria-hidden="true"
                        className="w-full h-full object-fill md:h-[101%]"
                        priority
                    />
                </div>
            </div>
        </section>
    );
}

export default BannerSlider;
